import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Message } from 'primeng/api';
import { StorageService } from '../../../../services/system/storage.service';
import { ListingOptionsService } from '../../../../services/listing-options.service';
import { ListingOption, OptionValue, ViewTypeEnum } from '../../../../models/inModels/MarketPlaceModel';


@Component({
  selector: 'app-edit-listing-option',
  templateUrl: './edit-listing-option.component.html',
  styleUrls: ['./edit-listing-option.component.css']
})
export class EditListingOptionComponent implements OnInit {
  model: ListingOption;
  loading = false;
  error: Message[];
  messages: Message[];
  id: number;
  viewTypeEnum = ViewTypeEnum;
  constructor(
    public storageService: StorageService,
    private router: Router,
    private route: ActivatedRoute,
    private service: ListingOptionsService) {
    this.model = new ListingOption();
    if(!this.model.values) {
      this.model.values = [];
    }
  }

  ngOnInit() {
    this.loading = true;
    this.id = this.route.snapshot.params.Id;
    this.service.get(this.id).then(
      res => {
        this.model = new ListingOption(res);
        if(!this.model.values) {
          this.model.values = [];
        }
        this.loading = false;
      },
      error => {
        this.loading = false;
        this.messages = [];
        this.messages.push({ severity: 'error', summary: 'Error', detail: error });
      });
  }

  addValue() {
    if(!this.model.values) {
      this.model.values = [];
    }
    const ov = new OptionValue({ Id: 0, Name: '', Value: '', OptionId: this.model.id || 0, IsCustom: false, Deleted: false });
    this.model.values.push(ov);
  }

  removeValue(index: number) {
    if(this.model.values && index > -1 && index < this.model.values.length) {
      const value = this.model.values[index];
      if (value.id && value.id > 0) {
        this.service.deleteOptionValue(value.id).then(
          (res) => {
            this.model.values.splice(index,1);
          }
        );
      } else {
        this.model.values.splice(index,1);
      }
    }
  }

  goBack(): void {
    this.router.navigate(['/marketplace/listing-options']);
  }

  save() {
    this.loading = true;
    this.service.update(this.model).then(
      res => {
        this.model = new ListingOption(res);
        this.loading = false;
        this.goBack();
      },
      error => {
        this.loading = false;
        this.error = [];
        this.error.push({ severity: 'error', summary: 'Error', detail: error });
      });
  }

  saveOptionValue(val: OptionValue) {
    this.loading = true;
    if (val.id && val.id > 0) {
      this.service.updateOptionValue(val).then(
        res => {
          const value = new OptionValue(res);
          this.loading = false;
          this.goBack();
        },
        error => {
          this.loading = false;
          this.error = [];
          this.error.push({ severity: 'error', summary: 'Error', detail: error });
        });
    } else {
      this.service.createOptionValue(val).then(
        res => {
          const value = new OptionValue(res);
          this.loading = false;
          this.goBack();
        },
        error => {
          this.loading = false;
          this.error = [];
          this.error.push({ severity: 'error', summary: 'Error', detail: error });
        });
    }
  }

  handleError(event): void {
    this.loading = false;
    this.error = [];
    this.storageService.handleError(event, this.error);
  }
}


// WEBPACK FOOTER //
// ./src/app/components/listing-option/edit/option/edit-listing-option.component.ts